import React from 'react';

// RichText block — optional <h2> + paragraphs. Plain strings only (no HTML injection). Presentation
// only. Active and available for authoring; unused by the Phase-1 default service content.
export default function RichText({ heading, body }) {
  return (
    <section className="mb-10 max-w-2xl">
      {heading ? (
        <h2 className="mb-4 font-heading text-2xl font-bold text-black">{heading}</h2>
      ) : null}
      {body.map((p, i) => (
        <p key={i} className="mb-4 leading-relaxed text-neutral-600">{p}</p>
      ))}
    </section>
  );
}
